import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { DetailsUI } from './details';
import { ListingUI } from './listing';
import { getUrlPrefix } from './utils';
const initApp = () => {
    const container = document.getElementById('procurements-view-app-container');
    const root = createRoot(container);
    root.render((React.createElement(React.StrictMode, null,
        React.createElement(BrowserRouter, null,
            React.createElement("section", { className: "container-fluid py-3 d-flex flex-column flex-grow-1" },
                React.createElement(Routes, null,
                    React.createElement(Route, { path: `${getUrlPrefix()}d/:numberSlug`, element: React.createElement(DetailsUI, null) }),
                    React.createElement(Route, { path: `${getUrlPrefix()}/`, element: React.createElement(ListingUI, null) })))))));
};
(function () {
    const state = document.readyState;
    if (state === 'interactive' || state === 'complete') {
        return initApp();
    }
    document.addEventListener('DOMContentLoaded', initApp);
})();
